<template>
  <figure
    class="identity__logo ba-w-84 lg:ba-w-128 xl:ba-w-auto ba-max-w-xl ba-mb-8 md:ba-mb-36 ba-text-center"
  >
    <img
      v-if="false"
      src="/img/brand/white/logo.svg"
      class="ba-mb-4 ba-w-48 md:ba-w-76 xl:ba-w-136 ba-inline"
    />
    <h1
      class="ba-text-2xl lg:ba-text-4xl xl:ba-text-6xl ba-leading-tight ba-font-bold ba-text-center ba-uppercase"
    >
      {{ $t("login.title") }}
    </h1>
    <p
      v-if="false"
      class="ba-hidden lg:ba-block ba-text-center ba-max-w-sm ba-mt-5"
    >
      {{ $t("login.description") }}
    </p>
  </figure>
</template>

<script>
export default {
  name: "vis-login-header"
};
</script>
